export default __webpack_public_path__ + "static/media/rgs_big.ee481b60.jpg";